import type { Accessorials } from "@/Shared/types";
import { LocationContext } from "@freightsimple/generated-dashboard-openapi-client/models/LocationContext";
import { LocationType } from "@freightsimple/generated-dashboard-openapi-client/models/LocationType";
import { generateAccessorialTypes } from "@/Data/generateAccessorialTypes";

export function nameAccessorialsExplicitly(
  accessorials: Accessorials,
  scope: LocationContext,
  locationType: LocationType,
) {
  return generateAccessorialTypes(locationType)
    .filter(function (a) {
      if (
        scope === LocationContext.Pickup &&
        a.type === "SCHEDULING_APPOINTMENT_REQUIRED"
      ) {
        return false;
      } else {
        return true;
      }
    })
    .map(function (a) {
      if (accessorials.includes(a.type)) {
        return a.name;
      } else {
        return scope === LocationContext.Pickup
          ? a.counterPickup
          : a.counterDelivery;
      }
    });
}
